import { Controller } from "@hotwired/stimulus"
import { loadStripe } from "@stripe/stripe-js";


export default class extends Controller {
  static targets = [
    "form",
    "submitText",
    "submitButton",
    "spinner",
    "errorMessage"
  ]
  static values = {
    publishableKey: String,
    locale: String,
    clientSecret: String,
    returnUrl: String,
    currency: String,
    countryCode: String,
  }

  connect() {
    this.initStripe().then(() => {
      this.mount_card_element()
    })
  }

  async initStripe() {
    this.stripe = await loadStripe(this.publishableKeyValue, { locale: this.localeValue });
  }

  mount_card_element() {
    const elements = this.stripe.elements();
    const style = {
      base: {
        iconColor: '#71BF43',
        color: '#000',
        backgroundColor: '#fff',
        fontFamily: 'Rubik, Roboto, Open Sans, Segoe UI, sans-serif',
        fontWeight: 100,
        fontSize: '16px',
        fontSmoothing: 'antialiased',
        ':-webkit-autofill': {
          color: '#fce883'
        },
        '::placeholder': {
          color: '#A9A9A9'
        }
      },
      invalid: {
        iconColor: '#DC143C',
        color: '#DC143C',
      },
    }

    this.cardElement = elements.create('card', { hidePostalCode: true, style: style })
    this.cardElement.mount('#card-element')
  }

  async handleSubmit(e) {
    e.stopImmediatePropagation()
    e.preventDefault()
    this.setLoading(true)

    const { setupIntent, error } = await this.stripe.confirmCardSetup(
      this.clientSecretValue,
      {
        payment_method: {
          card: this.cardElement,
        },
        return_url: this.returnUrlValue,
      })

    if (setupIntent) {
      this.formTarget.payment_method.value = 'card'
      this.formTarget.submit()
    }

    if (error) {
      if (error.message) {
        this.showMessage(error.message);
      } else {
        this.showMessage("An unexpected error occured.");
      }
      this.setLoading(false);
    }
  }

  showMessage(messageText) {
    this.errorMessageTarget.classList.remove("hidden");
    this.errorMessageTarget.textContent = messageText;

    setTimeout(() => {
      this.errorMessageTarget.classList.add("hidden");
      this.errorMessageTarget.textContent = "";
    }, 8000);
  }

  setLoading(isLoading) {
    if (isLoading) {
      // Disable the button and show a spinner
      this.submitButtonTarget.disabled = true;
      this.spinnerTarget.classList.remove("hidden");
      this.submitTextTarget.classList.add("hidden");
    } else {
      this.submitButtonTarget.disabled = false;
      this.spinnerTarget.classList.add("hidden");
      this.submitTextTarget.classList.remove("hidden");
    }
  }
}
